module.exports = __webpack_public_path__ + "src/assets/img/secretmag.8fb6ec83.jpg";